import type { Cache } from '@urql/exchange-graphcache';
import type { graphql } from '@/gql/graphql';
import getInsertedReactionSummary from './insert_message_reaction_one/getInsertedReactionCount';
import getInsertedReactions from './insert_message_reaction_one/getInsertedReactions';
import InsertMessageReactionOneOptimisticFragment from './insert_message_reaction_one/InsertMessageReactionOneOptimisticFragment';

export default function insert_message_reaction_one(
  args: {
    object: ReturnType<typeof graphql.scalar<'message_reaction_insert_input'>>;
  },
  cache: Cache,
) {
  const messageId = args.object.message_id;
  const content = args.object.content;

  if (!messageId || !content) {
    return null;
  }

  const message = cache.readFragment(
    InsertMessageReactionOneOptimisticFragment,
    {
      __typename: 'message',
      id: messageId,
    },
  );

  if (!message) {
    return null;
  }

  const nextSummary = getInsertedReactionSummary(args.object, message);

  const nextReactions = getInsertedReactions(message.your_reactions, {
    __typename: 'message_reaction',
    id: args.object.id,
    content,
  });

  const result = {
    __typename: 'message_reaction',
    id: args.object.id,
    message: {
      __typename: 'message',
      id: messageId,
      reaction_count: nextSummary,
      your_reactions: nextReactions,
    },
  };

  return result;
}
